import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
const BatchClosing = Loadable(lazy(() => import("./BatchClosing")));
const CreateEdit = Loadable(lazy(() => import("./CreateEdit")));
const BatchView= Loadable(lazy(() => import("./BatchClosingView")));
const BatchRoutes = [
    {
        path: '/batch-closing',
        element: <BatchClosing />,
    },
    {
        path: '/batch-closing/add',
        element: <CreateEdit />,
    },
    {
        path: '/batch-closing/view/:id',
        element: <BatchView />,
    },
    {
        path: '/batch-closing/:id',
        element:<BatchView />,
    },
    {
        path: '/batch-closing/:status/:id',
        element: <BatchView />,
    },
]

export default BatchRoutes
